// extracted by mini-css-extract-plugin
export default {"discountBanner":"JR","topheader":"KR","navleft":"LR","navflexelem":"MR","navright":"NR","fixedtop":"OR","checkout_header_wrapper":"PR","hideBanner":"QR","abstop":"RR","subdesc":"SR","smallscreennav":"TR","nav_hidden":"UR","cancel_link":"VR","bottomnavcontainer":"WR","fixedbottom":"XR","animatedbottom":"YR","appear-bottom":"ZR","delayedbottom":"aS","long_banner":"bS","nofixed":"cS","black_friday":"eS"};
    if(module.hot) {
      // 1713809679084
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  